export default __webpack_public_path__ + "static/media/Vigdis Wiccan Band.38283368.jpg";